module.exports = __webpack_public_path__ + "img/02.d1f97955.jpg";